import { DELETE_ERROR_TIPS } from "@/pages/Survey/SurveyManagement/components/SurveyContent/config";
import { tran } from "@/utils/assist";
import { defineComponent, reactive, watch } from "@vue/composition-api";

const DeleteTips = defineComponent({
  props: {
    deleteTipsData: {
      type: Object,
      default: () => {
        return {
          isVisible: false,
          data: [],
          title: '',
          subTitle: ''
        }
      }
    },
    sourceType: {
      type: String,
      default: 'sourceType'
    }
  },
  setup(props, context) {
    const dialog = reactive({
      isVisible: false,
      data: [],
      title: ''
    })
    watch(() => props.deleteTipsData, (val) => {
      dialog.isVisible = val.isVisible;
      dialog.data = val.data;
      dialog.title = val.title || tran('common.delete')
    }, {
      deep: true
    })
    const handleClose = () => {
      dialog.isVisible = false
      dialog.data = []
    }
    const lsMap = {
      4: tran('personalCenter.research'),
      6: tran('personalCenter.warning'),
      7: tran('personalCenter.subscribe'),
    }
    return () => {
      return props.deleteTipsData.data?.length > 0 && <el-dialog
        visible={dialog.isVisible}
        width="440px"
        top="30vh"
        before-close={handleClose}
        class="check_detele_dialog"
      >
        <div slot="title" class="dialog-title-box">
          <div class="dialog-title-text">{props.deleteTipsData.title}</div>
        </div>
        <div class="dialog-body-box">
          <div>{props.deleteTipsData.subTitle}</div>
          {dialog?.data?.map(item => {
            return (
              <div>
                <div style={{ marginTop: '24px' }}>{lsMap[item.sceneType || item.sourceType]}</div>
                <div style={{ marginTop: '24px' }}>{item.sourceName.join(';')}</div>
              </div>
            )
          })}
        </div>
        <span slot="footer" class="dialog-footer-box">
          <el-button
            size="small"
            type="primary"
            onClick={handleClose}
          >
            {tran("template.I know")}
          </el-button>
        </span>
      </el-dialog>
    }
  }
})
export default DeleteTips;
